// frontend/src/api/support.js
import { apiClient } from './index';

const supportApi = {
  createTicket: async (ticketData) => {
    return await apiClient.post('/support/', ticketData);
  },

  // --- NEW: REPORT LISTING ---
  reportListing: async (reportData) => {
    // reportData: { item_id, item_name, item_type, reason, description }
    return await apiClient.post('/support/report', reportData);
  },

  getMyTickets: async () => {
    return await apiClient.get('/support/');
  },

  getTicketById: async (ticketId) => {
    return await apiClient.get(`/support/${ticketId}`);
  },

  replyToTicket: async (ticketId, messageData) => {
    return await apiClient.post(`/support/${ticketId}/reply`, messageData);
  },

  // Admin methods
  getAllTicketsAdmin: async (status = null) => {
    const url = status ? `/support/admin/all?status=${status}` : '/support/admin/all';
    return await apiClient.get(url);
  },

  updateTicketStatusAdmin: async (ticketId, status) => {
    return await apiClient.put(`/support/admin/${ticketId}/status`, { status });
  }
};

export { supportApi };